import store from '@/store/index'
import request from '@/utils/request'

// ========== ========== ========== 查询Api接口 ========== ========== =========
export function getScheme(url, params) {
  // 参数
  return request({
    url: url + '/find/getdefaultcontent', method: 'post', data: params
  })
}

export function getinspctparam(url, params) {
  // 参数
  return request({
    url: url + '/find/getinspctparam', method: 'post', data: params
  })
}

export function getcontentlist(url, params) {
  // 参数
  return request({
    url: url + '/find/getcontentlist', method: 'post', data: params
  })
}
export function getfindByCode(url, params) {
  // 参数
  return request({
    url: 'health/content/label/contentinfo/get/findByCode', method: 'get', params
  })
}
export function getByCode(url, code) {
  const params = {}
  params['token'] = store.getters['user/getToken']
  params['code'] = code
  // 参数
  return request({
    url: url + '/get/findByCode', method: 'get', params
  })
}

export function findAll(url, searchDataJson) {
  const dataJson = {}
  dataJson['searchData'] = searchDataJson
  const date = JSON.stringify(dataJson)
  const params = { 'token': store.getters['user/getToken'], 'data': date }
  // 参数
  return request({
    url: url + '/find/findAll', method: 'post', data: params
  })
}

export function findPage(url, searchDataJson, pageSize, pageNo) {
  const dataJson = {}
  dataJson['searchData'] = searchDataJson
  dataJson['pageSize'] = pageSize
  dataJson['pageNo'] = pageNo
  const date = JSON.stringify(dataJson)
  const params = { 'token': store.getters['user/getToken'], 'data': date }

  // 参数
  return request({
    url: url + '/find/findPagination', method: 'post', data: params
  })
}

/**
 * 通过关键词搜索
 * @param url
 * @param keyword
 * @returns {AxiosPromise}
 */
export function findByKeyword(url, keyword) {
  const dataJson = {}
  dataJson['searchData'] = keyword
  const date = JSON.stringify(dataJson)
  const params = { 'token': store.getters['user/getToken'], 'data': date }

  // 参数
  return request({
    url: url + '/find/findbykeyword', method: 'post', data: params
  })
}
export function findByKeyword2(url, keyword) {
  let dataJson = {}
  dataJson = keyword
  const date = JSON.stringify(dataJson)
  const params = { 'token': store.getters['user/getToken'], 'data': date }

  // 参数
  return request({
    url: url + '/find/findbykeyword2', method: 'post', data: params
  })
}
export function findCount(model, entity, searchDataJson) {
  const searchData = JSON.stringify(searchDataJson)
  // searchData = encodeURIComponent(searchData)
  const params = {}
  params['token'] = store.getters['user/getToken']
  params['searchData'] = searchData
  // 参数
  return request({
    url: model + '/' + entity + '/find/count', method: 'get', params
  })
}

export function findPopup(url, searchDataJson, pageSign, pageSize, pageNo) {
  const dataJson = {}
  dataJson['searchData'] = searchDataJson
  if (pageSign) {
    dataJson['pageSize'] = pageSize
    dataJson['pageNo'] = pageNo
  }
  const date = JSON.stringify(dataJson)
  const params = { 'token': store.getters['user/getToken'], 'data': date }
  // 参数
  return request({
    url: url, method: 'post', data: params
  })
}
